<p-dialog
  modal="true"
  styleClass="atlas-dialog-s"
  position="top" [(visible)]="show"
  [closable]="false"
>
  <ng-template pTemplate="header"><ng-content select="atlas-header"></ng-content></ng-template>
  <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10" [wl-busy-overlay]="isLoading" [busyCenter]="true"   >
    <input class="mct-flex-1-1-0"  #link [(ngModel)]="linkText" readonly="readonly" (click)="$event.target.select()" />
    <wl-ephemeral-content-swap #contentSwap>
      <a ngxClipboard [cbContent]="linkText" (click)="contentSwap.show()">
        {{ 'common.copy-url' | translate }}
      </a>
      <div class="wl-ephemeral-content">
        {{ 'common.copied-to-clipboard' | translate | ucfirst }}
      </div>
    </wl-ephemeral-content-swap>
  </div>
  <ng-content></ng-content>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="close()">
      <span>{{ 'common.close' | translate | uppercase }}</span>
    </button>
  </ng-template>
</p-dialog>
